__turbopack_context__.v({
  "button": "SectionTitle-module-sass-module__OSRFIa__button",
  "rect-skeleton": "SectionTitle-module-sass-module__OSRFIa__rect-skeleton",
  "svg-skeleton": "SectionTitle-module-sass-module__OSRFIa__svg-skeleton",
  "title-link": "SectionTitle-module-sass-module__OSRFIa__title-link",
  "wrapper": "SectionTitle-module-sass-module__OSRFIa__wrapper",
});
